var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-app-bar",
        { attrs: { fixed: "", app: "", color: "#303030", dark: "" } },
        [
          _c(
            "a",
            {
              attrs: {
                href: "https://ezzeseguros.com.br",
                "x-large": "",
                flat: "",
                color: "transparent",
              },
            },
            [
              _c("v-img", {
                attrs: {
                  contain: "",
                  "max-width": "180",
                  src: require("./assets/logo-ezze.png"),
                },
              }),
            ],
            1
          ),
        ]
      ),
      _c("v-main", [_c("v-container", [_c("CadastroCorretor")], 1)], 1),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }